import type {
  User,
  Client,
  Project,
  Task,
  TimeEntry,
  Expense,
  Meeting,
} from '@/types';

export const mockUser: User = {
  id: 'user-1',
  email: 'freelancer@flowky.com',
  name: 'Alex Johnson',
  hourlyRate: 75,
  timezone: 'America/New_York',
  createdAt: '2025-01-01T00:00:00Z',
};

export const mockClients: Client[] = [
  {
    id: 'client-1',
    name: 'Acme Corp',
    type: 'business',
    hourlyRate: 80,
    contactInfo: 'contact@acmecorp.com',
    notes: 'Main client - web development projects',
    createdAt: '2025-01-05T00:00:00Z',
  },
  {
    id: 'client-2',
    name: 'Beta Inc',
    type: 'business',
    hourlyRate: 90,
    contactInfo: 'hello@betainc.com',
    notes: 'Mobile app development',
    createdAt: '2025-01-10T00:00:00Z',
  },
  {
    id: 'client-3',
    name: 'Gamma LLC',
    type: 'business',
    hourlyRate: 70,
    contactInfo: 'info@gammallc.com',
    createdAt: '2025-01-15T00:00:00Z',
  },
];

export const mockProjects: Project[] = [
  {
    id: 'project-1',
    clientId: 'client-1',
    name: 'E-commerce Platform',
    type: 'client',
    notes: 'Build a new e-commerce platform',
    createdAt: '2025-01-06T00:00:00Z',
  },
  {
    id: 'project-2',
    clientId: 'client-2',
    name: 'Mobile App Redesign',
    type: 'client',
    notes: 'Complete UI/UX overhaul',
    createdAt: '2025-01-11T00:00:00Z',
  },
  {
    id: 'project-3',
    clientId: 'client-3',
    name: 'API Integration',
    type: 'client',
    createdAt: '2025-01-16T00:00:00Z',
  },
  {
    id: 'project-4',
    clientId: 'user-1',
    name: 'Side Project X',
    type: 'side-project',
    notes: 'Personal SaaS project',
    createdAt: '2025-01-20T00:00:00Z',
  },
];

export const mockTasks: Task[] = [
  {
    id: 'task-1',
    title: 'Design homepage',
    description: 'Create homepage mockups and wireframes',
    clientId: 'client-1',
    projectId: 'project-1',
    priority: 'high',
    status: 'in-progress',
    deadline: '2025-09-29T00:00:00Z',
    origin: 'flowky',
    createdBy: 'user-1',
    createdAt: '2025-09-27T00:00:00Z',
    updatedAt: '2025-09-28T00:00:00Z',
  },
  {
    id: 'task-2',
    title: 'Implement login',
    description: 'Build authentication system',
    clientId: 'client-2',
    projectId: 'project-2',
    priority: 'medium',
    status: 'not-started',
    deadline: '2025-10-02T00:00:00Z',
    origin: 'flowky',
    createdBy: 'user-1',
    createdAt: '2025-09-26T00:00:00Z',
    updatedAt: '2025-09-26T00:00:00Z',
  },
  {
    id: 'task-3',
    title: 'Write blog post',
    description: 'Content for company blog',
    clientId: 'client-1',
    projectId: 'project-1',
    priority: 'low',
    status: 'not-started',
    deadline: '2025-10-03T00:00:00Z',
    origin: 'flowky',
    createdBy: 'user-1',
    createdAt: '2025-09-25T00:00:00Z',
    updatedAt: '2025-09-25T00:00:00Z',
  },
  {
    id: 'task-4',
    title: 'Create marketing plan',
    description: 'Q4 marketing strategy',
    clientId: 'client-1',
    projectId: 'project-1',
    priority: 'high',
    status: 'not-started',
    deadline: '2025-09-28T00:00:00Z',
    origin: 'flowky',
    createdBy: 'user-1',
    createdAt: '2025-09-24T00:00:00Z',
    updatedAt: '2025-09-24T00:00:00Z',
  },
];

export const mockTimeEntries: TimeEntry[] = [
  {
    id: 'time-1',
    userId: 'user-1',
    clientId: 'client-1',
    projectId: 'project-1',
    taskId: 'task-1',
    duration: 7200,
    date: '2025-09-28T00:00:00Z',
    startTime: '2025-09-28T08:00:00Z',
    description: 'Working on homepage design',
    type: 'pomodoro',
    createdAt: '2025-09-28T08:00:00Z',
  },
  {
    id: 'time-2',
    userId: 'user-1',
    clientId: 'client-2',
    projectId: 'project-2',
    duration: 5400,
    date: '2025-09-28T00:00:00Z',
    startTime: '2025-09-28T14:00:00Z',
    description: 'Mobile app redesign',
    type: 'manual',
    createdAt: '2025-09-28T14:00:00Z',
  },
  {
    id: 'time-3',
    userId: 'user-1',
    projectId: 'project-4',
    duration: 3600,
    date: '2025-09-27T00:00:00Z',
    startTime: '2025-09-27T10:00:00Z',
    description: 'Side project development',
    type: 'manual',
    createdAt: '2025-09-27T10:00:00Z',
  },
  {
    id: 'time-4',
    userId: 'user-1',
    projectId: 'project-4',
    duration: 5400,
    date: '2025-09-26T00:00:00Z',
    startTime: '2025-09-26T15:00:00Z',
    description: 'Feature implementation',
    type: 'pomodoro',
    createdAt: '2025-09-26T15:00:00Z',
  },
];

export const mockExpenses: Expense[] = [
  {
    id: 'expense-1',
    userId: 'user-1',
    amount: 29.99,
    category: 'Software',
    isRecurring: true,
    date: '2025-09-01T00:00:00Z',
    notes: 'GitHub Copilot subscription',
    createdAt: '2025-09-01T00:00:00Z',
  },
  {
    id: 'expense-2',
    userId: 'user-1',
    amount: 50,
    category: 'Hardware',
    clientId: 'client-1',
    projectId: 'project-1',
    isRecurring: false,
    date: '2025-09-15T00:00:00Z',
    notes: 'USB-C cable for client work',
    createdAt: '2025-09-15T00:00:00Z',
  },
];

export const mockMeetings: Meeting[] = [
  {
    id: 'meeting-1',
    userId: 'user-1',
    clientId: 'client-1',
    projectId: 'project-1',
    date: '2025-09-28T10:00:00Z',
    participants: ['Alex Johnson', 'John Doe', 'Sarah Wilson'],
    transcript: 'Alex: Good morning everyone, thanks for joining the call. John: Good morning Alex. Let\'s start with the project timeline. Alex: As discussed, we need to finalize the homepage design by end of week. John: That works for us. Sarah: I have some feedback on the wireframes. Alex: Great, let\'s go through that. Sarah: The navigation could be more intuitive. Alex: Agreed, I\'ll make those adjustments. John: When can we expect the first prototype? Alex: I\'m targeting next Friday. John: Perfect. Sarah: Should we schedule a follow-up for next week? Alex: Yes, let\'s do Tuesday 2 PM.',
    summary: 'Discussed project timeline and deliverables for Q4. Homepage design to be completed by end of week. First prototype delivery scheduled for next Friday. Follow-up meeting scheduled for Tuesday 2 PM. Navigation improvements needed based on Sarah\'s feedback.',
    actionItems: [
      { id: '1', task: 'Finalize homepage design', assignee: 'Alex Johnson', dueDate: '2025-10-04T00:00:00Z', completed: false },
      { id: '2', task: 'Create first prototype', assignee: 'Alex Johnson', dueDate: '2025-10-11T00:00:00Z', completed: false },
      { id: '3', task: 'Schedule follow-up meeting', assignee: 'Alex Johnson', dueDate: '2025-10-01T00:00:00Z', completed: true }
    ],
    linkedTasks: ['task-1'],
    createdAt: '2025-09-28T11:00:00Z',
  },
  {
    id: 'meeting-2',
    userId: 'user-1',
    clientId: 'client-3',
    projectId: 'project-3',
    date: '2025-09-27T14:00:00Z',
    participants: ['Alex Johnson', 'Jane Smith', 'Bob Wilson'],
    transcript: 'Jane: Welcome everyone to the API integration project kickoff. Alex: Thanks Jane, excited to get started. Bob: I\'ve prepared the API documentation. Alex: Great, I\'ve reviewed the initial specs. Jane: What\'s our timeline looking like? Alex: I estimate 3-4 weeks for full integration. Bob: That aligns with our launch schedule. Jane: Any potential blockers? Alex: The third-party API rate limits might be a concern. Bob: We can discuss increased limits with them. Jane: Let\'s plan weekly check-ins. Alex: Sounds good. I\'ll start with the authentication flow.',
    summary: 'Project kickoff meeting for API integration. Timeline set for 3-4 weeks. Weekly check-ins planned. Authentication flow to be implemented first. Need to address API rate limit concerns with third-party provider.',
    actionItems: [
      { id: '1', task: 'Implement authentication flow', assignee: 'Alex Johnson', dueDate: '2025-10-04T00:00:00Z', completed: false },
      { id: '2', task: 'Contact third-party for rate limit increase', assignee: 'Bob Wilson', dueDate: '2025-10-02T00:00:00Z', completed: false },
      { id: '3', task: 'Schedule weekly check-ins', assignee: 'Jane Smith', dueDate: '2025-09-30T00:00:00Z', completed: true }
    ],
    createdAt: '2025-09-27T15:00:00Z',
  },
  {
    id: 'meeting-3',
    userId: 'user-1',
    clientId: 'client-2',
    projectId: 'project-2',
    date: '2025-09-26T16:00:00Z',
    participants: ['Alex Johnson', 'Mike Chen', 'Lisa Rodriguez'],
    transcript: 'Mike: Hi Alex, thanks for joining. Alex: Hi Mike, happy to discuss the redesign. Lisa: We\'ve been reviewing the current mobile app. Alex: What are the main pain points? Mike: User engagement is down 15% this quarter. Lisa: The navigation is confusing users. Alex: I can help streamline the UX flow. Mike: What would be your approach? Alex: I\'d start with user journey mapping. Lisa: How long would that take? Alex: About a week for comprehensive analysis. Mike: That sounds reasonable. Lisa: When can you start? Alex: I can begin Monday.',
    summary: 'Mobile app redesign discussion. User engagement down 15% due to confusing navigation. User journey mapping to be completed first. Project to start Monday with UX flow improvements.',
    actionItems: [
      { id: '1', task: 'Start user journey mapping', assignee: 'Alex Johnson', dueDate: '2025-09-30T00:00:00Z', completed: false },
      { id: '2', task: 'Provide current app analytics', assignee: 'Lisa Rodriguez', dueDate: '2025-09-29T00:00:00Z', completed: false }
    ],
    linkedTasks: ['task-2'],
    createdAt: '2025-09-26T17:00:00Z',
  },
  {
    id: 'meeting-4',
    userId: 'user-1',
    clientId: 'client-1',
    projectId: 'project-1',
    date: '2025-09-25T13:00:00Z',
    participants: ['Alex Johnson', 'John Doe'],
    transcript: 'John: Alex, quick check-in on the blog content. Alex: Yes, I have the outline ready. John: Great, what topics are you covering? Alex: Company culture, recent product updates, and industry trends. John: Perfect fit for our Q4 content strategy. Alex: I should have the first draft by Friday. John: Excellent, I\'ll review over the weekend. Alex: Any specific tone or style preferences? John: Keep it conversational but professional. Alex: Got it, I\'ll incorporate our brand voice guidelines.',
    summary: 'Blog content check-in. Outline covering company culture, product updates, and industry trends. First draft due Friday. Conversational but professional tone requested.',
    actionItems: [
      { id: '1', task: 'Complete first blog draft', assignee: 'Alex Johnson', dueDate: '2025-09-27T00:00:00Z', completed: true },
      { id: '2', task: 'Review blog draft', assignee: 'John Doe', dueDate: '2025-09-29T00:00:00Z', completed: false }
    ],
    linkedTasks: ['task-3'],
    createdAt: '2025-09-25T14:00:00Z',
  },
  {
    id: 'meeting-5',
    userId: 'user-1',
    clientId: 'client-1',
    date: '2025-09-24T11:00:00Z',
    participants: ['Alex Johnson', 'John Doe', 'Sarah Wilson', 'Mark Thompson'],
    transcript: 'John: Team, we need to finalize our Q4 marketing strategy. Alex: I\'ve been working on the content calendar. Sarah: The budget allocation looks good. Mark: What about the digital campaigns? Alex: I suggest focusing on LinkedIn and targeted blog content. John: How does that align with our goals? Alex: It should increase qualified leads by 25%. Sarah: The ROI projections look promising. Mark: When can we launch? Alex: I need two weeks to prepare all materials. John: That puts us right on schedule.',
    summary: 'Q4 marketing strategy finalization. Content calendar in progress. Focus on LinkedIn and blog content for 25% lead increase. Launch in two weeks with promising ROI projections.',
    actionItems: [
      { id: '1', task: 'Finalize content calendar', assignee: 'Alex Johnson', dueDate: '2025-10-08T00:00:00Z', completed: false },
      { id: '2', task: 'Prepare marketing materials', assignee: 'Alex Johnson', dueDate: '2025-10-08T00:00:00Z', completed: false },
      { id: '3', task: 'Review budget allocation', assignee: 'Sarah Wilson', dueDate: '2025-10-01T00:00:00Z', completed: true }
    ],
    linkedTasks: ['task-4'],
    createdAt: '2025-09-24T12:00:00Z',
  },
];

export const mockAISuggestions = [
  'You have 3 high-priority tasks due today',
  'You might be overworking this weekend—consider rescheduling',
  'Side project X is lagging—consider scheduling 2 Pomodoros',
];